window.fit = window.fit || {};

(function($) {

  fit.Accordion = function(root) {
    this.root = root;
    this.root.ready(this._transormFileLink.bind(this));
    this.root.on('click', this.root.find('.js-accordion-head'), this._accordionToggle.bind(this));
    this.root.find('.js-accordion-navigation-trigger').click(this._navigationToggle.bind(this));
    $(window).on('load hashchange', this._goToSection.bind(this));
    $(window).on("load", this._expandAccordion.bind(this));
  };

  fit.Accordion.prototype = {
    _goToSection: function () {
      if (window.location.hash) {
        var hash = window.location.hash.substring(1);
        if (hash.includes("afsnit")) {
          dataToggle = hash.split("-")[1];
          const target = this.root.find("[data-toggle=" + dataToggle + "]");

          target
            .addClass("is-expanded")
            .find(".js-accordion-body")
            .slideDown({
              complete: function () {
                if (target.length > 0) {
                  $("html, body").animate(
                    {
                      scrollTop: target.offset().top,
                    },
                    400
                  );
                }
              },
            });
        }
      }
    },
    _expandAccordion: function () {
      currentAccordionItem = $(".js-accordion-item");
      if (currentAccordionItem.hasClass("is-expanded")) {
        // Collapse current accordion item
        currentAccordionItem
          .find(".js-accordion-body")
          .css({ display: "block" });
      }
    },
    _transormFileLink: function (e) {
      // Exclude buttons and links classes
      let fileLinks = this.root.find("a:not(.link):not(.button)");
      for (let i = 0; i < fileLinks.length; i++) {
        // Get extension from link href attribute
        let fileLinkExtension = fileLinks[i]
          .getAttribute("href")
          .split(/[#?]/)[0]
          .split(".")
          .pop()
          .trim();

        // If extension is not an empty string add link class and icon attribute
        if (fileLinkExtension) {
          fileLinks[i].classList.add("link");
          fileLinks[i].setAttribute("data-icon", fileLinkExtension);
        }
      }
    },

    _accordionToggle: function (e) {
      if (!$(e.target).hasClass("js-accordion-head")) {
        return;
      }

      let currentAccordionItem = $(e.target).parents(".js-accordion-item");

      // Stop propagation for links inside accordion head
      if (e.target.classList.contains("link")) e.target.stopPropagation();

      // If current accordion item is expanded
      if (currentAccordionItem.hasClass("is-expanded")) {
        // Collapse current accordion item
        currentAccordionItem
          .removeClass("is-expanded")
          .find(".js-accordion-body")
          .slideUp();
      }
      // If current accordion item is collapsed
      else {
        // Expand current accordion item
        let scrollTarget = $(
          "[data-toggle=" + currentAccordionItem.data("toggle") + "]"
        );
        currentAccordionItem
          .addClass("is-expanded")
          .find(".js-accordion-body")
          .slideDown({
            complete: function () {
              // Scroll to current accordion item
              if (scrollTarget.length > 0) {
                $("html, body").animate(
                  {
                    scrollTop: scrollTarget.offset().top,
                  },
                  400
                );
              }
            },
          });
      }
    },

    _navigationToggle: function (e) {
      let dataToggle = $(e.target).attr("data-toggle");

      // Expand accordion item with the same data-toggle id
      $(".js-accordion-item[data-toggle=" + dataToggle + "]")
        .find(".js-accordion-body")
        .slideDown();
      $(".js-accordion-item[data-toggle=" + dataToggle + "]").addClass(
        "is-expanded"
      );

      // Scroll to accordion item with the same data-toggle id
      let scrollTarget = $("[data-toggle=" + dataToggle + "]");
      setTimeout(function () {
        $("html, body").animate(
          {
            scrollTop: scrollTarget.offset().top,
          },
          400
        );
      }, 200);
    },
  };

  $('.js-accordion').each(function() {
    new fit.Accordion($(this));
  });

})(jQuery);